import React from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    title: 'Plan Alimenticio para Regenerar y Equilibrar Tus Hormonas',
    desc: 'Un plan simple con alimentos que ayudan a reducir inflamación, mejorar el metabolismo y apoyar el equilibrio hormonal de forma natural.',
    img: 'https://cdn.magicpatterns.com/uploads/n11BmXugWi9UoGeWhDNYsi/bono_1.png'
  }, {
    id: 2,
    title: 'Recetario de Infusiones y Tés para Equilibrar Tus Hormonas',
    desc: 'Recetas de infusiones naturales que ayudan a reducir el estrés, mejorar el descanso y apoyar el equilibrio hormonal.',
    img: 'https://cdn.magicpatterns.com/uploads/xbx6BpgaHuXCbMsSy4scb2/bono_2.png'
  }, {
    id: 3,
    title: 'Plan Detox Natural de 7 Días',
    desc: 'Un protocolo sencillo para ayudar a tu cuerpo a eliminar toxinas, reducir inflamación y recuperar energía.',
    img: 'https://cdn.magicpatterns.com/uploads/mbhGSPcrQKboFzabf7seou/bono_3.png'
  }, {
    id: 4,
    title: 'Guía de Suplementos para el Equilibrio Hormonal Femenino',
    desc: 'Aprendé qué suplementos naturales pueden ayudarte a apoyar tu sistema hormonal y mejorar tu bienestar.',
    img: 'https://cdn.magicpatterns.com/uploads/wfpWzGZhe1VBq9VJK3Mxzr/bono_4.png'
  }];
  return <section className="py-16 px-4 bg-brand-cream" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-21">
            Pero eso no es todo.
          </h2>
          <p className="text-xl text-gray-700" data-id="element-22">
            Para ayudarte a aplicar todo de forma práctica, también vas a
            recibir{' '}
            <strong className="text-brand-green" data-id="element-23">4 bonos exclusivos</strong>{' '}
            incluidos con tu compra.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-24">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-brand-gold/20 flex flex-col" data-id="element-25">
              <div className="bg-brand-red text-white text-center py-2 font-bold tracking-wide text-sm uppercase flex items-center justify-center gap-2" data-id="element-26">
                <GiftIcon className="w-4 h-4" data-id="element-27" />
                GRATIS POR HOY
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-28">
                <div className="flex justify-center mb-6 cursor-pointer group" onClick={scrollToOffer} data-id="element-29">
                  <img src={bonus.img} alt={bonus.title} className="h-64 object-contain drop-shadow-xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-30" />
                </div>
                <div className="text-center" data-id="element-31">
                  <span className="inline-block bg-brand-gold/20 text-brand-green font-bold px-3 py-1 rounded-full text-sm mb-3" data-id="element-32">
                    BONO {bonus.id}
                  </span>
                  <h3 className="text-xl font-bold mb-3 text-brand-green" data-id="element-33">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-34">{bonus.desc}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}